import { render, staticRenderFns } from "./ItemAcquire.vue?vue&type=template&id=a732a054&scoped=true&"
import script from "./ItemAcquire.vue?vue&type=script&lang=js&"
export * from "./ItemAcquire.vue?vue&type=script&lang=js&"
import style0 from "./ItemAcquire.vue?vue&type=style&index=0&id=a732a054&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a732a054",
  null
  
)

export default component.exports